<script setup lang="ts">
defineProps<{ }>()
const emit = defineEmits<{ (e: 'import'): void }>()

const steps = [
  { n: 1, t: 'Import a document', d: 'Add a PDF or image — drag it in or use Import.' },
  { n: 2, t: 'Pick a Snip mode', d: 'Text, Sum, Table, Validation or Exception.' },
  { n: 3, t: 'Draw a box', d: 'Select a region on the page to capture it.' },
  { n: 4, t: 'It lands in Excel', d: 'The snip is written to the selected cell, colour-coded.' },
]
</script>

<template>
  <div class="welcome scroll">
    <img src="/assets/icon-64.png" alt="SnipCell" class="logo" />
    <h1>SnipCell <span class="tag">Reforged</span></h1>
    <p class="lede">Capture snips from PDFs &amp; images straight into Excel — text, sums, and tables.</p>

    <button class="primary big" @click="emit('import')">Import a document</button>
    <p class="drop muted">…or drag &amp; drop a file anywhere here.</p>

    <ol class="steps">
      <li v-for="s in steps" :key="s.n">
        <span class="num">{{ s.n }}</span>
        <span><strong>{{ s.t }}</strong><br /><span class="muted">{{ s.d }}</span></span>
      </li>
    </ol>
  </div>
</template>

<style scoped>
.welcome {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 28px 20px;
  gap: 8px;
}
.logo { width: 56px; height: 56px; }
h1 { margin: 4px 0 0; font-size: 20px; }
h1 .tag {
  font-size: 12px;
  vertical-align: super;
  color: var(--brand);
  font-weight: 600;
}
.lede { color: var(--muted); margin: 4px 0 14px; max-width: 280px; }
.big { padding: 9px 18px; font-size: 14px; }
.drop { margin: 8px 0 18px; font-size: 12px; }
.steps {
  list-style: none;
  padding: 0;
  margin: 0;
  width: 100%;
  max-width: 300px;
  text-align: left;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.steps li { display: flex; gap: 10px; align-items: flex-start; }
.num {
  flex: none;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: var(--brand);
  color: #fff;
  display: grid;
  place-items: center;
  font-size: 12px;
  font-weight: 700;
}
</style>
